import { abyssColors, ANNOTATION_BACKGROUND_COLOR } from '@/theme/colors';
import { Box, Stack, Typography, styled as muiStyled } from '@mui/material';

export const Arrow = muiStyled(Box)(() => ({
  height: 0,
  position: 'absolute',
  top: '-0.1rem',
  borderLeft: '0.8rem solid transparent',
  borderRight: '0.8rem solid transparent',
  borderTop: `0.9rem solid ${ANNOTATION_BACKGROUND_COLOR}`,
}));

export const Ellipse = muiStyled(Box)(() => ({
  width: '0.6rem',
  height: '0.6rem',
  backgroundColor: abyssColors.error[500],
  borderRadius: '50%',
  aspectRatio: '1/1',
}));

export const Content = muiStyled(Stack)({
  background: ANNOTATION_BACKGROUND_COLOR,
  padding: '0.8rem',
  borderRadius: '0.4rem',
  width: '100%',
  height: 'fit-content',
  gap: '0.4rem',
});

export const Detail = muiStyled(Stack)(() => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const Title = muiStyled(Typography)(() => ({
  fontFamily: 'Inter',
  fontWeight: 600,
  fontSize: '1rem',
  color: abyssColors.neutral[50],
  lineHeight: '1.2rem',
  whiteSpace: 'nowrap',
}));

export const DetailLabel = muiStyled(Title)(() => ({
  fontWeight: 500,
}));

export const DetailValue = muiStyled(Typography)(() => ({
  fontFamily: 'Roboto',
  fontWeight: 500,
  fontSize: '1rem',
  color: abyssColors.neutral[50],
  lineHeight: '100%',
  textAlign: 'right',
}));
